import { Box } from "@chakra-ui/react"
import { OnOrderFulfilledCallback } from "@pathwright/features/src/modules/order/useOrderPollingQuery"
import { useOnRegistrationOrderFulilled } from "../register/components/OrderRegistrationButton"
import RegisterFlow from "../register/components/RegisterFlow"

function OfferRegisterPanelComponent({
  resourceSlug,
  cohortId,
  orderId,
  offeringOption,
  inviteToken,
  onOrderFulfilled,
  attemptToConvert,
  offerConversionActionLabel
}: {
  resourceSlug: string
  cohortId: number
  orderId?: number
  offeringOption?: number
  inviteToken?: string | null
  onOrderFulfilled: OnOrderFulfilledCallback
  attemptToConvert: boolean
  offerConversionActionLabel?: string
}) {
  const onRegistrationOrderFulfilled =
    useOnRegistrationOrderFulilled(onOrderFulfilled)

  return (
    <Box
      className="CoverPageRegisterAdapter"
      display="flex"
      alignItems="flex-start"
      justifyContent="center"
      h="100%"
      w="100%"
      overflowY="auto"
      borderRadius={{ base: "20px", md: 0 }}
      css={{
        "& .RegisterFlow": {
          bgColor: "transparent"
        },
        "& .RegisterFlow .RegisterHeader__close, & .RegisterFlow .RegisterFlowHeader":
          {
            display: "none"
          },
        "& .RegisterFlow .Gates": {
          bg: "none",
          p: 0
        },
        "& .RegisterFlow .AuthWrapper": {
          px: 0,
          py: 4
        },
        // Remove padding from subscribe flow when auth container is present.
        "& .RegisterFlow .OrderSubscriptionFlow:has(.AdaptedAuthContainer) .SubscriptionOptions > div":
          {
            p: 0
          },
        "& .RegisterFlow .OrderSubscriptionFlow:has(.AdaptedAuthContainer) .SubscriptionOptions > div > div":
          {
            p: 0
          },
        "& .RegisterFlow .SignedInFooter": {
          p: 0
        },
        "& .RegisterFlow .OrderSubscriptionFlow": {
          p: 0
        }
      }}
    >
      <RegisterFlow
        resourceSlug={resourceSlug}
        cohortId={cohortId}
        orderId={orderId}
        offeringOption={offeringOption}
        inviteToken={inviteToken}
        onOrderFulfilled={onRegistrationOrderFulfilled}
        attemptToConvert={attemptToConvert}
        offerConversionActionLabel={offerConversionActionLabel}
      />
    </Box>
  )
}

export default OfferRegisterPanelComponent
